/**
 * @module app.cm
 */

import { autoinject } from 'aurelia-framework';
import { AppLogger } from 'app/shared/lib/logging/app-logger';
import { IContactLogConfig } from 'app/core/models/essette-interfaces';

@autoinject()
export class ManageContactLogPage {

    ////****************** Fields and Properties ************************************////
    protected config: IContactLogConfig = {
        serviceRootUrl: 'cm/cases',
        targetType: 'CM.Case',
        moduleCode: 'CM'
    };

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly logger: AppLogger) {
        this.logger.source = this;
    }

    ////****************** Element References ***************************************////

    ////****************** Functions ************************************************////

}
